import './styles.css';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, ConfigProvider } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';
import { ordersSelectors } from '../../features/orders';

const OrderFailure = () => {
    const navigate = useNavigate();
    const { orderId } = useParams();

    const lastOrder = useSelector(ordersSelectors.selectLastOrder);
    const orderNumber = lastOrder?.order_number;
    const orderTotal = lastOrder?.total;
    const paymentUrl = useSelector((state) =>
        ordersSelectors.selectPaymentUrl(state, orderId || lastOrder?.id)
    );

    if (!lastOrder) {
        return (
            <div className="order-failure-page">
                <div className="order-failure-card">
                    <CloseCircleFilled className="order-failure-icon" />
                    <div className="order-failure-title">Оплата не прошла</div>
                    <div className="order-failure-subtitle">
                        К сожалению, оплата не была завершена.
                    </div>
                    <div className="order-failure-actions">
                        <Button type="primary" onClick={() => navigate('/cart')}>
                            Вернуться в корзину
                        </Button>
                        <Button onClick={() => navigate('/')}>
                            На главную
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#D00202',
                },
                components: {
                    Button: {
                        colorPrimaryHover: '#ff3333',
                    },
                }
            }}
        >
            <div className="order-failure-page">
                <div className="order-failure-card">
                    <CloseCircleFilled className="order-failure-icon" />
                    <div className="order-failure-title">Оплата не прошла</div>
                    <div className="order-failure-subtitle">
                        К сожалению, оплата не была завершена. Вы можете попробовать оплатить заказ повторно.
                    </div>

                    {lastOrder && (
                        <div className="order-failure-details">
                            {orderNumber && (
                                <div className="order-detail-row">
                                    <span className="order-detail-label">Номер заказа</span>
                                    <span className="order-detail-value">#{orderNumber}</span>
                                </div>
                            )}
                            {orderTotal && (
                                <div className="order-detail-row">
                                    <span className="order-detail-label">Сумма</span>
                                    <span className="order-detail-value">
                                        {Math.round(Number(orderTotal)).toLocaleString()}₽
                                    </span>
                                </div>
                            )}
                        </div>
                    )}

                    <div className="order-failure-actions">
                        {paymentUrl && (
                            <Button
                                type="primary"
                                onClick={() => window.open(paymentUrl, '_blank')}
                            >
                                Попробовать снова
                            </Button>
                        )}
                        <Button onClick={() => navigate('/')}>
                            На главную
                        </Button>
                        <Button onClick={() => navigate('/profile')}>
                            Мои заказы
                        </Button>
                    </div>
                </div>
            </div>
        </ConfigProvider>
    );
};

export default OrderFailure;
